import { motion } from "framer-motion";

const ESSAYS = [
    {
        title: "The True Fall Was Not Disobedience",
        body: "We were told the Fall was an apple — a rule broken, a woman blamed. But the true fall was quieter and far more devastating: a grieving boy, standing over a grave he dug himself, whispering I wish I did not have to feel this. Disobedience did not exile us from the garden. Emotional shutdown did. Every wall built since has been made of the same stones.",
    },
    {
        title: "The Question That Heals",
        body: "Every wound in this story turns on a single question: What hurts? Eve asked it of a frightened boy. A father finally asks it of his daughter. A son asks it of the man who once told him not to cry. It is the antidote to the serpent's lie — and healing, it turns out, can travel backward through generations as surely as the wound traveled forward.",
    },
    {
        title: "The Rose Grows in the Cracks",
        body: "A boy picks a rose for his mother every morning, because she is the most beautiful flower in the garden. A man lays the last one on her grave. A daughter places one in her father's open hand. The rose is love, remembrance, and the garden within — and it cannot be destroyed. It grows in the cracks of every wall we ever built. It grows in you.",
    },
];

export default function ReflectionsSection() {
    return (
        <section id="blog" data-testid="reflections-section" className="relative mx-auto max-w-6xl px-6 py-32">
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 1 }}
                className="text-center"
            >
                <p className="font-cinzel text-xs tracking-[0.4em] text-[#b89860] uppercase">
                    From the World of the Book
                </p>
                <h2 className="font-cinzel mt-6 text-3xl leading-snug text-[#f3e5ab] sm:text-5xl">
                    Essays & Reflections
                </h2>
            </motion.div>

            <div className="mt-20 grid gap-8 md:grid-cols-3">
                {ESSAYS.map((essay, i) => (
                    <motion.article
                        key={essay.title}
                        data-testid={`reflection-${i + 1}`}
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.9, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
                        className="rounded-sm border border-[rgba(212,175,55,0.22)] bg-[rgba(15,35,24,0.55)] p-8 backdrop-blur-md transition-[border-color,box-shadow] duration-300 hover:border-[rgba(212,175,55,0.5)] hover:shadow-[0_0_40px_rgba(255,200,100,0.08)]"
                    >
                        <span className="font-cinzel text-[0.6rem] tracking-[0.35em] text-[#b89860] uppercase">
                            Reflection {["I", "II", "III"][i]}
                        </span>
                        <h3 className="font-cinzel mt-4 text-lg leading-snug text-[#f3e5ab]">
                            {essay.title}
                        </h3>
                        <p className="font-cormorant mt-5 text-base leading-relaxed text-[#a3b899]">
                            {essay.body}
                        </p>
                    </motion.article>
                ))}
            </div>
        </section>
    );
}
